<!-- header -->
<app-header extraClass="text-gray nav-down" standardProduct=true displayNavigation=true></app-header>

<section class="reschedule-wrp mt-120">
    <div class="container mb-3">
        <div class="wrap-all mt-4">

            <div class="booking-card">
                <h4 class="heading">Your Experience Details</h4>
                <div class="uk-flex card">
                    <div class="image">
                        <img src="assets/images/banner-1.jpg" alt="" class="fitimg">
                    </div>
                    <div class="info">
                        <h4>Tasting Session at Bayroute</h4>
                        <p>Relationships, Mumbai</p>
                        <span>Booked for:</span>
                        <h3>26 July 2022</h3>
                        <span class="mt-2">Order ID: 2345</span>
                    </div>
                </div>
            </div>
            <!--booking-card end-->

            <div class="reschedule-date-time-all mt-4 mb-3">
                <div class="heading">
                    <h4>Reschedule your experience</h4>
                    <p>Please select your preferred date, & time slot <br> and an OTP will be sent to confirm</p>
                </div>

                <div class="select-date-wrp mt-5">
                    <h4>Choose your Date</h4>

                    <div class="radio-group-wrp">
                        <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slider="sets: true">
                            <ul class="uk-slider-items">
                                <li>
                                    <div class="radio-tile-group">
                                        <p>Mon</p>
                                        <div class="input-container">
                                            <input id="day1" class="radio-button" type="radio" name="radio" />
                                            <div class="radio-tile">
                                                <h3>22</h3>
                                                <label for="day1" class="radio-tile-label">Aug</label>
                                            </div>
                                        </div>
                                    </div>
                                    <!--radio-tile-group end-->
                                </li>
                                <li>
                                    <div class="radio-tile-group">
                                    <p>Tue</p>
                                    <div class="input-container">
                                        <input id="day2" class="radio-button" type="radio" name="radio" />
                                        <div class="radio-tile">
                                            <h3>23</h3>
                                            <label for="day2" class="radio-tile-label">Aug</label>
                                        </div>
                                    </div>
                                    </div>
                                    <!--radio-tile-group end-->
                                </li>
                                <li>
                                    <div class="radio-tile-group">
                                        <p>Wed</p>
                                        <div class="input-container">
                                            <input id="day3" class="radio-button" type="radio" name="radio" />
                                            <div class="radio-tile">
                                                <h3>24</h3>
                                                <label for="day3" class="radio-tile-label">Aug</label>
                                            </div>
                                        </div>
                                    </div>
                                    <!--radio-tile-group end-->
                                </li>
                                <li>
                                    <div class="radio-tile-group">
                                        <p>Thu</p>
                                        <div class="input-container">
                                            <input id="day4" class="radio-button" type="radio" name="radio" />
                                            <div class="radio-tile">
                                                <h3>25</h3>
                                                <label for="day4" class="radio-tile-label">Aug</label>
                                            </div>
                                        </div>
                                    </div>
                                    <!--radio-tile-group end-->
                                </li>
                                <li>
                                    <div class="radio-tile-group">
                                        <p>Fri</p>
                                        <div class="input-container">
                                            <input id="day5" class="radio-button" type="radio" name="radio" />
                                            <div class="radio-tile">
                                                <h3>26</h3>
                                                <label for="day5" class="radio-tile-label">Aug</label>
                                            </div>
                                        </div>
                                    </div>
                                    <!--radio-tile-group end-->
                                </li>
                                <li>
                                    <div class="radio-tile-group">
                                        <p>Sat</p>
                                        <div class="input-container">
                                            <input id="day6" class="radio-button" type="radio" name="radio" />
                                            <div class="radio-tile">
                                                <h3>27</h3>
                                                <label for="day6" class="radio-tile-label">Aug</label>
                                            </div>
                                        </div>
                                    </div>
                                    <!--radio-tile-group end-->
                                </li>
                                <li>
                                    <div class="radio-tile-group">
                                        <p>Sun</p>
                                        <div class="input-container">
                                            <input id="day7" class="radio-button" type="radio" name="radio" />
                                            <div class="radio-tile">
                                                <h3>28</h3>
                                                <label for="day7" class="radio-tile-label">Aug</label>
                                            </div>
                                        </div>
                                    </div>
                                    <!--radio-tile-group end-->
                                </li>
                            </ul>
        
                            <a class="uk-position-center-left uk-position-small" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
                            <a class="uk-position-center-right uk-position-small" href="#" uk-slidenav-next uk-slider-item="next"></a>
                        </div>
                    </div>

                </div>
                <!--select-date-wrp end-->

                <div class="select-time-wrp mt-4">
                    <h4>Select the timeslot</h4>

                    <div class="radio-time-wrp">

                        <div class="radio-tile-group">
                            <div class="input-container">
                                <input id="time1" class="radio-button" type="radio" name="time" />
                                <div class="radio-tile">
                                    <label for="time1" class="radio-tile-label">16:30-18:30</label>
                                </div>
                            </div>
                        </div>
                        <!--radio-tile-group end-->

                        <div class="radio-tile-group">
                            <div class="input-container">
                                <input id="time2" class="radio-button" type="radio" name="time" />
                                <div class="radio-tile">
                                    <label for="time2" class="radio-tile-label">16:30-18:30</label>
                                </div>
                            </div>
                        </div>
                        <!--radio-tile-group end-->

                    </div>
                </div>


                <div class="btn-box mt-4">
                    <a >Confirm</a>
                </div>


            </div>

        </div>

        <div class="need-help uk-flex uk-flex-middle uk-flex-between mt-2 mb-2">
            <div class="info">
                <h4>Need our Help?</h4>
                <p>Reach out to us if you have any questions!</p>
            </div>
            <div class="number">
                <a href="tel:18002667666"> <img src="assets/images/icons/call-5.png" alt=""> 1800 266 7666</a>
            </div>
        </div>

        <div class="cancel-order-wrp">
            <h4>And if you wish to cancel this order</h4>
            <a href="#modal-example" uk-toggle>Request Cancellation</a>
        </div>

    </div>
</section>

<div class="footer-bottom">
    <div class="container">
        <p>Copyright © 2017 - 2022 things2do. All rights reserved.</p>
    </div>
</div>

<!-- This is the modal -->
<div id="modal-example" uk-modal class="reschedule-model" bg-close="false">
    <div class="uk-modal-dialog uk-modal-body">
        <div class="heading">
            <h4>Order Cancellation</h4>
        </div>
        <p>Are you sure <br>
        you want to cancel your Experience ?</p>
        <div class="btn-group uk-flex uk-flex-center">
            <a href="#modal-center" uk-toggle class="btn-default">Yes</a>
            <a href="#" class="btn-yellow uk-modal-close">No</a>
        </div>
    </div>
</div>